module.exports = __webpack_public_path__ + "static/img/paws-heart.91a75e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nurses/paws-heart.svg
// module id = BkW9
// module chunks = 1